import shortid from 'shortid';

export const DROPPABLE_IDS = {
  ReportSetup: 'ReportSetup',
  HeaderOptions: 'HeaderOptions',
};

export const DroppableAreaEnum = {
  ReportSection: 'ReportSection',
  OptionsSection: 'OptionsSection',
};

export const SelectedReportOptionsMaxColumnsPerRow = 4;

export const Modals = {
  CreateNewReport: 'CreateNewReport',
};

export const Pages = {
  SelectTemplate: 'SelectTemplate',
  AssignMenuMealType: 'AssignMenuMealType',
};

export const Templates = {
  Simple: 1,
  Detailed: 2,
  Complex: 3,
};

export const MealTypes = {
  Breakfast: 'Breakfast',
  Lunch: 'Lunch',
  SaladBar: 'Salad Bar',
  SnackBar: 'Snack Bar',
  Supper: 'Supper',
  Other: 'Other',
};

export const NonOtherMealTypes = [
  MealTypes.Breakfast,
  MealTypes.Lunch,
  MealTypes.SaladBar,
  MealTypes.SnackBar,
  MealTypes.Supper,
];

export const AllMealTypes = [
  MealTypes.Breakfast,
  MealTypes.Lunch,
  MealTypes.SaladBar,
  MealTypes.SnackBar,
  MealTypes.Supper,
  MealTypes.Other,
];

export const REPORT_WRITER_TABS = {
  ReportHeader: 'ReportHeader',
  Planned: 'Planned',
  Offered: 'Offered',
  Served: 'Served',
};

export const REPORT_OPTIONS_SECTION_TITLE = {
  0: 'Header Options',
  1: 'Planned Options',
  2: 'Offered Options',
  3: 'Served Options',
};

export const REPORT_SECTION_TABS = [
  REPORT_WRITER_TABS.ReportHeader,
  REPORT_WRITER_TABS.Planned,
  REPORT_WRITER_TABS.Offered,
  REPORT_WRITER_TABS.Served,
];

export const SIMPLE_TEMPLATE_OPTIONS = {
  ReportHeader: [
    {
      Description: 'Entree Meal List',
      Required: false,
    },
    {
      Description: 'Plate Count',
      Required: false,
    },
    {
      Description: 'School Site Address',
      Required: false,
    },
    {
      Description: 'School District',
      Required: false,
    },
    {
      Description: 'Water Available',
      Required: false,
    },
    {
      Description: 'Meal Type',
      Required: true,
    },
    {
      Description: 'Notes',
      Required: false,
    },
    {
      Description: 'School / Site Name',
      Required: true,
    },
    {
      Description: 'Grade Level',
      Required: true,
    },
    {
      Description: 'Number Served',
      Required: true,
    },
    {
      Description: 'Offer vs Served',
      Required: false,
    },
    {
      Description: 'Manager Signature',
      Required: false,
    },
    {
      Description: 'Personnel',
      Required: false,
    },
    {
      Description: 'Date',
      Required: true,
    },
  ],
  Planned: [
    {
      Description: 'Recipe #',
      Required: false,
    },
    {
      Description: 'Food Item',
      Required: true,
    },
    {
      Description: 'Contributions',
      Required: false,
    },
    {
      Description: 'Planned Portions',
      Required: true,
    },
    {
      Description: 'Portion Size',
      Required: true,
    },
    {
      Description: 'Units for 100 Servings',
      Required: false,
    },
    {
      Description: 'USDA',
      Required: false,
    },
  ],
  Offered: [
    {
      Description: 'Comments',
      Required: false,
    },
    {
      Description: 'Food Item Temp',
      Required: false,
    },
    {
      Description: 'Portions Prepared',
      Required: true,
    },
  ],
  Served: [
    {
      Description: 'Waste',
      Required: false,
    },
    {
      Description: 'Food Item Temp',
      Required: false,
    },
    {
      Description: 'Service Line',
      Required: false,
    },
    {
      Description: 'Comments',
      Required: false,
    },
    {
      Description: 'Portions Served',
      Required: true,
    },
    {
      Description: 'Leftovers',
      Required: true,
    },
  ],
};

export const DETAILED_TEMPLATE_OPTIONS = {
  ReportHeader: [
    {
      Description: 'Date',
      Required: true,
    },
    {
      Description: 'School District',
      Required: false,
    },
    {
      Description: 'School / Site Name',
      Required: true,
    },
    {
      Description: 'Manager Signature',
      Required: false,
    },
    {
      Description: 'Entree Meal List',
      Required: false,
    },
    {
      Description: 'Nutrition Standards',
      Required: true,
    },
    {
      Description: 'Number Served',
      Required: true,
    },
    {
      Description: 'Notes',
      Required: true,
    },

    {
      Description: 'Plate Count',
      Required: false,
    },
    {
      Description: 'Offer vs Served',
      Required: false,
    },
    {
      Description: 'Personnel',
      Required: false,
    },
    {
      Description: 'School Site Address',
      Required: false,
    },
    {
      Description: 'Water Available',
      Required: false,
    },
  ],
  Planned: [
    {
      Description: 'Contributions',
      Required: true,
    },
    {
      Description: 'Portions Offered',
      Required: true,
    },
    {
      Description: 'Portion Size',
      Required: true,
    },
    {
      Description: 'USDA',
      Required: false,
    },
    {
      Description: 'Units for 100 Servings',
      Required: false,
    },
  ],
  Offered: [
    {
      Description: 'Portions Offered',
      Required: true,
    },
    {
      Description: 'Service Line',
      Required: false,
    },
    {
      Description: 'Comments',
      Required: false,
    },
    {
      Description: 'Food Item Temp',
      Required: false,
    },
  ],
  Served: [
    {
      Description: 'Portions Served',
      Required: true,
    },
    {
      Description: 'Leftovers',
      Required: true,
    },
    {
      Description: 'Food Item Temp',
      Required: false,
    },
    {
      Description: 'Waste',
      Required: false,
    },
    {
      Description: 'Comments',
      Required: false,
    },
    {
      Description: 'Service Line',
      Required: false,
    },
  ],
};

export const COMPLEX_TEMPLATE_OPTIONS = {
  ReportHeader: [
    {
      Description: 'Nutrition Standards',
      Required: true,
    },
    {
      Description: 'Entree Meal List',
      Required: false,
    },
    {
      Description: 'Offer vs Served',
      Required: false,
    },

    {
      Description: 'School/Site Name ',
      Required: true,
    },
    {
      Description: 'Notes',
      Required: false,
    },
    {
      Description: 'Manager Signature',
      Required: false,
    },
    {
      Description: 'Number Served',
      Required: true,
    },
    {
      Description: 'Water Available',
      Required: false,
    },
    {
      Description: 'Personnel',
      Required: false,
    },
    {
      Description: 'Date',
      Required: true,
    },
  ],
  Planned: [
    {
      Description: 'Contributions',
      Required: true,
    },
    {
      Description: 'Planned Portions',
      Required: true,
    },
    {
      Description: 'Portion Size',
      Required: true,
    },
    {
      Description: 'USDA',
      Required: false,
    },
    {
      Description: 'Units for 100 Servings',
      Required: false,
    },
  ],
  Offered: [
    {
      Description: 'Portions Offered',
      Required: true,
    },
    {
      Description: 'Service Line',
      Required: true,
    },
    {
      Description: 'Food Item Temp',
      Required: false,
    },
    {
      Description: 'Comments',
      Required: false,
    },
  ],
  Served: [
    {
      Description: 'Portions Served',
      Required: true,
    },
    {
      Description: 'Leftovers',
      Required: true,
    },
    {
      Description: 'Food Item Temp',
      Required: false,
    },
    {
      Description: 'Waste',
      Required: false,
    },
    {
      Description: 'Comments',
      Required: false,
    },
    {
      Description: 'Service Line',
      Required: false,
    },
  ],
};

export const INITIAL_SIMPLE_TEMPLATE_OPTIONS = {
  ReportHeader: [
    {
      Description: 'Entree Meal List',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Plate Count',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'School Site Address',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'School District',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Water Available',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Planned: [
    {
      Description: 'Units for 100 Servings',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'USDA',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Offered: [
    {
      Description: 'Comments',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Food Item Temp',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Served: [
    {
      Description: 'Waste',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Food Item Temp',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Service Line',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Comments',
      Required: false,
      Id: shortid.generate(),
    },
  ],
};

export const INITIAL_DETAILED_TEMPLATE_OPTIONS = {
  ReportHeader: [
    {
      Description: 'Plate Count',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Offer vs Served',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Personnel',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'School Site Address',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Water Available',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Planned: [
    {
      Description: 'Units for 100 Servings',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Offered: [
    {
      Description: 'Comments',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Food Item Temp',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Served: [
    {
      Description: 'Service Line',
      Required: false,
      Id: shortid.generate(),
    },
  ],
};

export const INITIAL_SIMPLE_TEMPLATE_SECTIONS = {
  ReportHeader: [
    [
      {
        Description: 'Meal Type',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Notes',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'School / Site Name',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Grade Level',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Number Served',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Offer vs Served',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Manager Signature',
        Required: false,
        Id: shortid.generate(),
      },
      {
        Description: 'Personnel',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Date',
        Required: true,
        Id: shortid.generate(),
      },
    ],
  ],
  Planned: [
    [
      {
        Description: 'Recipe #',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Food Item',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Contributions',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Planned Portions',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Portion Size',
        Required: true,
        Id: shortid.generate(),
      },
    ],
  ],
  Offered: [
    [
      {
        Description: 'Portions Prepared',
        Required: true,
        Id: shortid.generate(),
      },
    ],
  ],
  Served: [
    [
      {
        Description: 'Portions Served',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Leftovers',
        Required: true,
        Id: shortid.generate(),
      },
    ],
  ],
};

export const INITIAL_DETAILED_TEMPLATE_SECTIONS = {
  ReportHeader: [
    [
      {
        Description: 'Date',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'School District',
        Required: false,
        Id: shortid.generate(),
      },
      {
        Description: 'School / Site Name',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Manager Signature',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Entree Meal List',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Nutrition Standards',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Number Served',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Notes',
        Required: false,
        Id: shortid.generate(),
      },
    ],
  ],
  Planned: [
    [
      {
        Description: 'Contributions',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Portions Offered',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Portion Size',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'USDA',
        Required: false,
        Id: shortid.generate(),
      },
    ],
  ],
  Offered: [
    [
      {
        Description: 'Portions Offered',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Service Line',
        Required: false,
        Id: shortid.generate(),
      },
    ],
  ],
  Served: [
    [
      {
        Description: 'Portions Served',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Leftovers',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Food Item Temp',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Waste',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Comments',
        Required: false,
        Id: shortid.generate(),
      },
    ],
  ],
};

export const INITIAL_COMPLEX_TEMPLATE_OPTIONS = {
  ReportHeader: [
    {
      Description: 'Nutrition Standards',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Entree Meal List',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Offer vs Served',
      Required: false,
      Id: shortid.generate(),
    },

    {
      Description: 'School/Site Name ',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Notes',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Manager Signature',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Number Served',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Water Available',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Personnel',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Date',
      Required: true,
      Id: shortid.generate(),
    },
  ],
  Planned: [
    {
      Description: 'Contributions',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Planned Portions',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Portion Size',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'USDA',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Units for 100 Servings',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Offered: [
    {
      Description: 'Portions Offered',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Service Line',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Food Item Temp',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Comments',
      Required: false,
      Id: shortid.generate(),
    },
  ],
  Served: [
    {
      Description: 'Portions Served',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Leftovers',
      Required: true,
      Id: shortid.generate(),
    },
    {
      Description: 'Food Item Temp',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Waste',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Comments',
      Required: false,
      Id: shortid.generate(),
    },
    {
      Description: 'Service Line',
      Required: false,
      Id: shortid.generate(),
    },
  ],
};

export const INITIAL_COMPLEX_TEMPLATE_SECTIONS = {
  ReportHeader: [
    [
      {
        Description: 'Nutrition Standards',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Entree Meal List',
        Required: false,
      },
      {
        Description: 'Offer vs Served',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'School/Site Name ',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Notes',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Manager Signature',
        Required: false,
        Id: shortid.generate(),
      },
      {
        Description: 'Number Served',
        Required: true,
        Id: shortid.generate(),
      },
      {
        Description: 'Water Available',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Personnel',
        Required: false,
        Id: shortid.generate(),
      },
      {
        Description: 'Date',
        Required: true,
        Id: shortid.generate(),
      },
    ],
  ],
  Planned: [
    [
      {
        Description: 'Contributions',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Portions Offered',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Portion Size',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'USDA',
        Required: false,
        Id: shortid.generate(),
      },
    ],
  ],
  Offered: [
    [
      {
        Description: 'Portions Offered',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Service Line',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Food Item Temp',
        Required: false,
        Id: shortid.generate(),
      },
      {
        Description: 'Comments',
        Required: false,
        Id: shortid.generate(),
      },
    ],
  ],
  Served: [
    [
      {
        Description: 'Portions Served',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Leftovers',
        Required: true,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Food Item Temp',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Waste',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Comments',
        Required: false,
        Id: shortid.generate(),
      },
    ],
    [
      {
        Description: 'Service Line',
        Required: false,
        Id: shortid.generate(),
      },
    ],
  ],
};

export const ValuesByTemplate = {
  1: {
    InitialSection: INITIAL_SIMPLE_TEMPLATE_SECTIONS,
    InitialOption: INITIAL_SIMPLE_TEMPLATE_OPTIONS,
    Options: SIMPLE_TEMPLATE_OPTIONS,
  },
  2: {
    InitialSection: INITIAL_DETAILED_TEMPLATE_SECTIONS,
    InitialOption: INITIAL_DETAILED_TEMPLATE_OPTIONS,
    Options: DETAILED_TEMPLATE_OPTIONS,
  },
  3: {
    InitialSection: INITIAL_COMPLEX_TEMPLATE_SECTIONS,
    InitialOption: INITIAL_COMPLEX_TEMPLATE_OPTIONS,
    Options: COMPLEX_TEMPLATE_OPTIONS,
  },
};



// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/helpers/Constants.js